import { columns } from "../../../../dtos/columns";
import { ErrorCarga } from "../models/registrarRecaudacionMasiva";


export function useColumnsError() {
    const COLUMNS: columns<ErrorCarga>[] = [

        {
            name: 'Campo',
            selector: (row) => row.campo,
            sortable: true,
            sortField: 'campo',
            wrap: true,
            export: true
        },
        {
            name: 'Tipo registro',
            selector: (row) => row.tipoRegistro,
            sortable: true,
            sortField: 'tipoRegistro',
            wrap: true,
            export: true
        },
        {
            name: 'Número linea',
            selector: (row) => row.numeroLinea,
            sortable: true,
            sortField: 'numeroLinea',
            wrap: true,
            export: true
        },
        {
            name: 'Descripción error',
            selector: (row) => row.descripcionError,
            sortable: true,
            sortField: 'descripcionError',
            wrap: true,
            export: true
        },

    ];

    return {COLUMNS}
}